export default {
    routes_templates_modal_cloneRoute_title: "Clonar Ruta",
    routes_templates_modal_cloneRoute_label: "Asigne un nombre a la ruta a clonar",
    routes_templates_modal_cloneRoute_name: "Nombre",
    routes_templates_modal_cloneRoute_sucess: "Ruta clonada con éxito"
}